import React, { FC } from 'react';
import { FormatTime } from 'components/organisms/timesheets/common/format-time';
import { CellRendererParams } from 'components/organisms/timesheets/drawers/calendar-integration/add-activity-page/activity-table';

export const EffortRenderer: FC<CellRendererParams> = ({ value }) => (
  <FormatTime value={value} />
);
